export default class eSesjaDiscussionListState {
    static AddedToList = new eSesjaDiscussionListState("AddedToList");
    static RemovedFromList = new eSesjaDiscussionListState("RemovedFromList");
    static GotSpeechFromList = new eSesjaDiscussionListState("GotSpeechFromList");
    static EndSpeech = new eSesjaDiscussionListState("EndSpeech");
    static GotSpeechFromGuestList = new eSesjaDiscussionListState("GotSpeechFromGuestList");
            constructor(name) {
        this.name = name;
    }
}